import React from 'react'
import PropTypes from 'prop-types'
import { BottomNavigation, BottomNavigationAction, Box, Paper } from '@mui/material'
import { Route, Routes, Link as RouterLink, useLocation } from 'react-router-dom'
import MovieFilterOutlinedIcon from '@mui/icons-material/MovieFilterOutlined'
import VideoLibraryOutlinedIcon from '@mui/icons-material/VideoLibraryOutlined'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import HighlightsAppBar from './menu/HighlightsAppBar'
import Highlight from '../pages/Highlight'
import UploadFile from '../pages/UploadFile'
import Uploads from '../pages/Uploads'
import Upload from '../pages/Upload'
import Tag from '../pages/Tag'
import Stats from '../pages/Stats'
import Groups from '../pages/Groups'
import Admin from '../pages/Admin'
import Players from '../pages/Players'
import Game from '../pages/Game'
import Settings from '../pages/Settings'
import { SettingsProvider } from '../settings/SettingsContext'
import AppErrorBoundary from './AppErrorBoundary'
import TermsGate from './TermsGate'

export default function AppShell ({ testMode = false }) {
  const location = useLocation()
  const navValue = location.pathname.startsWith('/uploads') || location.pathname.startsWith('/upload/')
    ? '/uploads'
    : location.pathname.startsWith('/new')
      ? '/new'
      : '/'

  // The upload workspace sizes its video to the window, so it gets slimmer page margins.
  const editorRoute = location.pathname === '/upload' || location.pathname.startsWith('/upload/')

  return (
    <SettingsProvider>
      <HighlightsAppBar testMode={testMode} />
      <TermsGate />
      <Box
        component="main"
        sx={{
          px: editorRoute ? { xs: 1, sm: 2 } : { xs: 1, sm: 2, lg: 3 },
          pb: editorRoute ? { xs: 10, md: 1 } : { xs: 10, md: 3 },
          maxWidth: 1920,
          mx: 'auto'
        }}
      >
        <AppErrorBoundary>
          <Routes>
            <Route path="/" element={<Highlight />} />
            <Route path="/highlight" element={<Highlight />} />
            <Route path="/new" element={<UploadFile />} />
            <Route path="/uploads" element={<Uploads />} />
            <Route path="/upload" element={<Upload />} />
            <Route path="/upload/:uploadId" element={<Upload />} />
            <Route path="/upload/:uploadId/highlight/:highlightId" element={<Upload />} />
            <Route path="/tag" element={<Tag />} />
            <Route path="/tag/:tag" element={<Tag />} />
            <Route path="/stats" element={<Stats />} />
            <Route path="/groups" element={<Groups />} />
            <Route path="/players" element={<Players />} />
            <Route path="/game/:gameId" element={<Game />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </AppErrorBoundary>
      </Box>

      <Paper
        elevation={8}
        sx={{
          display: { xs: 'block', md: 'none' },
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: theme => theme.zIndex.appBar,
          borderTop: '1px solid',
          borderColor: 'divider'
        }}
      >
        <BottomNavigation
          showLabels
          value={navValue}
          sx={{ '& .MuiBottomNavigationAction-label': { fontSize: 13 }, '& .MuiBottomNavigationAction-label.Mui-selected': { fontSize: 14 } }}
        >
          <BottomNavigationAction
            label="Highlights"
            value="/"
            icon={<MovieFilterOutlinedIcon />}
            component={RouterLink}
            to="/"
          />
          <BottomNavigationAction
            label="Uploads"
            value="/uploads"
            icon={<VideoLibraryOutlinedIcon />}
            component={RouterLink}
            to="/uploads"
          />
          <BottomNavigationAction
            label="Upload"
            value="/new"
            icon={<AddCircleOutlineIcon />}
            component={RouterLink}
            to="/new"
          />
        </BottomNavigation>
      </Paper>
    </SettingsProvider>
  )
}

AppShell.propTypes = {
  testMode: PropTypes.bool
}
